module.exports = __webpack_public_path__ + "img/login_robot.f1e78b6b.png";